import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import Button from '../../../../components/Button'

function ButtonChangeText({ className, textToChange, textTimeout = 3000, children, onClick, ...props }) {
  const [showChangedText, setShowChangedText] = useState(false)
  const timeoutRef = useRef(null)

  const handleClick = useCallback(
    e => {
      setShowChangedText(true)
      onClick(e)

      // Clear any existing timeout to avoid duplicate timers
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }

      timeoutRef.current = setTimeout(() => {
        setShowChangedText(false)
        timeoutRef.current = null
      }, textTimeout)
    },
    [onClick, textTimeout]
  )

  useEffect(() => {
    // Cleanup function clears the timeout when the component unmounts
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  return (
    <Button className={className} onClick={handleClick} {...props}>
      {showChangedText ? textToChange : children}
    </Button>
  )
}

ButtonChangeText.propTypes = {
  className: PropTypes.string,
  textToChange: PropTypes.string.isRequired,
  textTimeout: PropTypes.number,
  onClick: PropTypes.func.isRequired
}

export default ButtonChangeText
